<template>
  <div class="echarts-content">
    <div class="echarts" :style="{height: windowHeight + 'px'} ">
      <chart theme="macarons" :options="polar" ref="echar" :init-options="initOptions" :auto-resize="true" @click="tap" />
    </div>
    <div class="echarts" :style="{height: windowHeight + 'px'} ">
      <chart :options="polar1" ref="echar" :init-options="initOptions" :auto-resize="true" @click="tap" />
    </div>
    <div class="echartList" style="">
      <el-table
        :data="analysisData"
        :style="{height: windowHeight + 'px',overflow: 'auto'} "
        >
        <el-table-column type="expand">
          <template slot-scope="props">
              <div class="dataListDetail" v-for="item in props.row.dataList" :key="item.areaCode" >
                <el-divider content-position="left">
                  <el-tag size="mini" >{{item.city}}</el-tag>
                </el-divider>
                <div class='flex-row'>
                  <span class='mark'>最近时间</span>
                  <span>{{new Date(item.recentlyCreateDate).format("yyyy-MM-dd")}}</span>
                </div>
                <div class='flex-row'>
                  <span class='mark'>历史吨位</span>
                  <span>共{{item.tonnage}}吨</span>
                </div>
                <div class='flex-row'>
                  <span class='mark'>历史金额</span>
                  <span @mouseover="show(item.money)" @mouseout="hide(item.money)">共{{money}}元</span>
                </div>
                <div class='flex-row'>
                  <span class='mark'>历史地点</span>
                  <span>{{item.areaName}}</span>
                </div>
                <div class='flex-row'>
                  <span class='mark'>运费范围</span>
                  <span>{{item.freightMin +' - '+ item.freightMax }}</span>
                </div>
              </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          width="180">
        </el-table-column>
        <el-table-column
          prop="sum"
          label="总数">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import theme from '../ECharts/macarons.json'
import 'echarts/theme/dark'
import {selectAnalysisByProvider} from '../api/ordersStatistics'
ECharts.registerTheme('macarons', theme)
export default {
  name: 'supplyCharts',
  props: {
    searchData: {
      default: {}
    },
    slider: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      windowHeight: '',
      info: {},
      money: '****',
      polar: {
        title: {
          x: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          bottom: 5,
          data: []
        },
        toolbox: {
          show: true,
          feature: {
            mark: {show: true},
            dataView: {show: true, readOnly: false},
            magicType: {
              show: true,
              type: ['pie', 'funnel']
            },
            restore: {show: true},
            saveAsImage: {show: true}
          }
        },
        calculable: true,
        series: []
      },
      polar1: {
        title: {
          text: '',
          x: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          bottom: 5,
          data: []
        },
        calculable: true,
        series: [
        ]
      },
      initOptions: {},
      analysisData: []
    }
  },
  watch: {
    slider (val) {
      if (val) {
        this.init(this.searchData)
      }
    }
  },
  created () {
    this.$nextTick(() => {
      this.windowHeight = document.documentElement.offsetHeight - 370
    })
  },
  methods: {
    show (i) {
      this.money = i
    },
    hide () {
      this.money = '****'
    },
    init () {
      let _this = this
      this.$refs.echar.clear()
      this.$refs.echar.showLoading()
      this.polar1.series = []
      selectAnalysisByProvider(this.searchData).then(res => {
        _this.$refs.echar.hideLoading()
        if (res.data.data == null) {
          this.polar.series = []
          _this.analysisData = []
          return
        }
        _this.analysisData = res.data.data
        let data = res.data.data
        _this.polar.title.text = this.searchData.areaName + '经理发货分布'
        _this.polar.legend.data = data.map(item => {
          return item.name
        })
        _this.polar.series = [{
          name: '发货比例',
          type: 'pie',
          // radius: [5, 110],
          // center: ['25%', '50%'],
          roseType: 'area',
          labelLine: {
            normal: {
              smooth: 0.2,
              length: 5,
              length2: 5
            }
          },
          label: {
            normal: {
              position: 'outside',
              formatter: '{b}：{c}次'
            }
          },
          data: data.map(i => {
            return {
              value: i.sum, name: i.name
            }
          })
        }]
      })
    },
    tap (params) {
      if (params.seriesIndex === 0) {
        let data = this.analysisData[params.dataIndex]
        this.polar1.title.text = data.name + '发货分布'
        this.polar1.legend.data = data.dataList.map(item => {
          return item.city
        })
        this.polar1.series = [{
          name: '分布比例',
          type: 'pie',
          // radius: [5, 110],
          // center: ['25%', '50%'],
          roseType: 'area',
          labelLine: {
            normal: {
              smooth: 0.2,
              length: 5,
              length2: 5
            }
          },
          label: {
            normal: {
              position: 'outside',
              formatter: '{b}：{c}次'
            }
          },
          data: data.dataList.map(i => {
            return {
              value: i.total, name: i.city
            }
          })
        }]
      }
    }
  },
  components: {
    chart: ECharts
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .echarts-content
    display flex
    flex-direction row
    justify-content space-between
  .echarts
    width: 100%
    height 100%
    margin-right: 5px
    text-align: center
    background: #fff
  .echartList
    margin-left 30px
    width 100%
    .el-table
      &:before
        height: 0 !important
  .dataListDetail
    font-size 12px
    margin -15px
    padding: 0 6px
    .flex-row
      display: flex
      flex-direction: row
      margin-bottom: 10px
      color: #999
      .mark
        margin-right: 30px
        white-space: nowrap
        color: #999
</style>
